import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/inactive/Breadcrumb";
import TransactionDetailLayer from "../../components/TransactionDetailLayer";

const TransactionDetailPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Invoice - List" />

        {/* InvoiceListLayer */}
        <TransactionDetailLayer />
      </MasterLayout>
    </>
  );
};

export default TransactionDetailPage;
